module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.downloadProfitSummaryRpt
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n        ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-menu', {
    ref: "startDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "250px",
            "max-width": "250px"
          },
          attrs: {
            "label": "Start Date",
            "placeholder": "Start Date",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDateCal),
      callback: function($$v) {
        _vm.startDateCal = $$v
      },
      expression: "startDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }, [_c('v-spacer')], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "date-divider"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('v-menu', {
    ref: "endDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-3",
          staticStyle: {
            "min-width": "250px",
            "max-width": "250px"
          },
          attrs: {
            "label": "End Date",
            "placeholder": "End Date",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDateCal),
      callback: function($$v) {
        _vm.endDateCal = $$v
      },
      expression: "endDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }, [_c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "pt-0",
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.getProfitSumary
    }
  }, [_vm._v("Apply")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row mt-3",
    staticStyle: {
      "justify-content": "space-between",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Profit Summary for " + _vm._s(_vm.currentMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.currentMthProfit)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "sm8": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Profit Summary " + _vm._s(_vm.showFilterDate))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.profit)))])])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.filterQuaters), function(quater, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-btn', _vm._g(_vm._b({
      attrs: {
        "color": quater.selected ? 'warning' : 'default',
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeQuater(quater.value)
        }
      }
    }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n            " + _vm._s(quater.label) + "\n          ")])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('v-data-table', {
    ref: "ProfitSummaryTable",
    staticClass: "profit-summary-table elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "items-per-page": 15
    },
    on: {
      "current-items": _vm.getFiltered
    },
    scopedSlots: _vm._u([_vm._l((_vm.headers), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "iconColor": "#fb8c00"
            }
          })]
        }
      }
    }), {
      key: "item.createdAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.createdAt) ? _c('span', [_vm._v(_vm._s(_vm.formatDateTime(item.createdAt)))]) : _vm._e()])]
      }
    }, {
      key: "item.IONumber",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.IONumber) ? _c('span', [_vm._v(_vm._s(item.IONumber))]) : _vm._e()])]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.budget) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))]) : _vm._e()])]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.amount) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e()])]
      }
    }, {
      key: "item.cogsTotal",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.cogsTotal) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsTotal)))]) : _vm._e()])]
      }
    }, {
      key: "item.targetCOGS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.targetCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.targetCOGS)))]) : _vm._e()])]
      }
    }, {
      key: "item.actualCOGS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.actualCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.actualCOGS)))]) : _vm._e()])]
      }
    }, {
      key: "item.savingCOGS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.savingCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.savingCOGS)) + " " + _vm._s(item.savingPercent ? ("(" + (item.savingPercent) + "%)") : ''))]) : _vm._e()])]
      }
    }, {
      key: "item.grossProfit",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.grossProfit) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.grossProfit)))]) : _vm._e()])]
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3324e6cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/ProfitSummary/DataTable.vue
// module id = 2070
// module chunks = 0